import { api } from '@setplex/tria-api'
import { createEvent, createStore, sample, split } from 'effector'

import type {
  LiveEventPaymentInfo,
  MovieBundlePaymentInfo,
  MoviePaymentInfo,
  TvBundlePaymentInfo,
  TvChannelPaymentInfo,
  TvShowBundlePaymentInfo,
  TvShowEpisodePaymentInfo,
  TvShowPaymentInfo,
  TvShowSeasonPaymentInfo,
} from '../index.h'

interface PaymentInfoUnion
  extends LiveEventPaymentInfo,
    MoviePaymentInfo,
    MovieBundlePaymentInfo,
    TvChannelPaymentInfo,
    TvBundlePaymentInfo,
    TvShowPaymentInfo,
    TvShowBundlePaymentInfo,
    TvShowEpisodePaymentInfo,
    TvShowSeasonPaymentInfo {}

export const postItemToCart = createEvent() // event for skin

export const postItemToCartWithPaymentInfo = createEvent<PaymentInfoUnion>()

export const postShowToCart = createEvent<{ tvShowId?: number }>()
export const postShowBundleToCart = createEvent<{
  tvShowSetId?: number
  tvShowIds?: number[]
  seasonIds?: number[]
  episodeIds?: number[]
}>()
export const postTvLiveEventToCart = createEvent<{ liveEventId?: number }>()
export const postVodEventToCart = createEvent<{ vodId?: number }>()
export const postVodBundleEventToCart = createEvent<{
  vodSetId?: number
  vodIds?: number[]
}>()
export const postTvEventToCart = createEvent<{ channelId?: number }>()
export const postTvBundleEventToCart = createEvent<{
  channelSetId?: number
  channelIds?: number[]
}>()
export const postShowEpisodeEventToCart = createEvent<{ episodeId?: number }>()
export const postShowSeasonBundleEventToCart = createEvent<{
  seasonId?: number
}>()

export const $liveEventInfoForCart = createStore<LiveEventPaymentInfo | null>(
  null
)
export const $movieInfoForCart = createStore<MoviePaymentInfo | null>(null)
export const $movieBundleInfoForCart =
  createStore<MovieBundlePaymentInfo | null>(null)
export const $tvShowInfoForCart = createStore<TvShowPaymentInfo | null>(null)
export const $tvChannelInfoForCart = createStore<TvChannelPaymentInfo | null>(
  null
)
export const $tvBundleInfoForCart = createStore<TvBundlePaymentInfo | null>(
  null
)
export const $tvShowBundleInfoForCart =
  createStore<TvShowBundlePaymentInfo | null>(null)
export const $tvShowEpisodeInfoForCart =
  createStore<TvShowEpisodePaymentInfo | null>(null)
export const $tvShowSeasonInfoForCart =
  createStore<TvShowSeasonPaymentInfo | null>(null)

const $lastItemPaymentInfo = createStore<PaymentInfoUnion | null>(null).on(
  [
    $liveEventInfoForCart,
    $movieInfoForCart,
    $movieBundleInfoForCart,
    $tvChannelInfoForCart,
    $tvBundleInfoForCart,
    $tvShowInfoForCart,
    $tvShowBundleInfoForCart,
    $tvShowEpisodeInfoForCart,
    $tvShowSeasonInfoForCart,
  ],
  (_, values) => values as PaymentInfoUnion
)

sample({
  clock: postItemToCart,
  source: $lastItemPaymentInfo,
  filter: Boolean,
  target: postItemToCartWithPaymentInfo,
})

split({
  source: postItemToCartWithPaymentInfo,
  match: {
    postShowToCart: (info) => info?.tvShowId != null,
    postTvLiveEventToCart: (info) => info?.liveEventId != null,
    postShowBundleToCart: (info) => info?.tvShowSetId != null,
    postVodEventToCart: (info) => info?.vodId != null,
    postVodBundleEventToCart: (info) => info?.vodSetId != null,
    postTvEventToCart: (info) => info?.channelId != null,
    postTvBundleEventToCart: (info) => info?.channelSetId != null,
    postShowEpisodeEventToCart: (info) => info?.episodeId != null,
    postShowSeasonBundleEventToCart: (info) => info?.seasonId != null,
  },
  cases: {
    postShowToCart,
    postTvLiveEventToCart,
    postShowBundleToCart,
    postVodEventToCart,
    postVodBundleEventToCart,
    postTvEventToCart,
    postTvBundleEventToCart,
    postShowEpisodeEventToCart,
    postShowSeasonBundleEventToCart,
  },
})

export const postItemToCartFx = api.cart.postItemToCartFx // TODO this should be an attach
